import React from 'react'
import bigLogo from '../../../img/big-vipe-logo.png';
import '../../styles/FormHeader.css';

const FormLogo = () => {
  return (
      <img src={bigLogo} alt="Vipe Logo" className='vipeLogo' />
  )
}

export default FormLogo